<template>
  <section class="container mt-12">
    <div class="row">
      <div class="col-12 col-sm-10 offset-sm-1 tit-wrap">
        <div class="tit-style mb-1">
          <h1><strong>BRAND</strong> Film</h1>
        </div>
        <p class="txt-tit-desc">
          자연의 아름다움 보타랩을 브랜드 필름을 통해 확인해 보세요!
        </p>
        <div class="text-center">
          <a href="https://www.youtube.com/channel/UCDfIKM3yZL25ZLdUbWQLVcQ" class="youtube-a" target="_blank">
            <img src="@/assets/images/common/ico_youtube_new_line.svg"  alt="유튜브" class="youtube-a--img">
          </a>
        </div>
        <!-- <div class="text-center">
          <span class="tag-style">#김태희</span>
          <span class="tag-style ml-1">#김하늘</span>
        </div> -->
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'TitleArea',

};
</script>
